export default __webpack_public_path__ + "2ca6a84b7dfcc7e1dc80f33a2503707c.jpg";